import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let lifeData = {};

try{
    // 尝试获取本地是否存在lifeData变量，第一次启动APP时是不存在的
    lifeData = uni.getStorageSync('czLifeData');
}catch(e){

}

// 需要永久存储，且下次APP启动需要取出的，在state中的变量名
let saveStateKeys = [
	'vuex_sys_version',//当前进入的系统标识
    'current_sys',//当前进入的系统标识
    'current_sys_title',//当前进入的系统标识
    'sso_user_token','sso_user_name','sso_sex','sso_company_name','sso_avatar','sso_discount_code',
    'cz_user_token','cz_user_name','cz_sex','cz_company_name','cz_avatar','cz_discount_code',
    'wms_user_token','wms_user_name','wms_sex','wms_company_name','wms_avatar','wms_discount_code',
    'zhfw_user_token','zhfw_user_name','zhfw_sex','zhfw_company_name','zhfw_avatar','zhfw_discount_code','car_open_id'
];


// 保存变量到本地存储中
const saveLifeData = function(key, value){
    // 判断变量名是否在需要存储的数组中
    if(saveStateKeys.indexOf(key) !== -1) {
        // 获取本地存储的lifeData对象，将变量添加到对象中
        let tmp = uni.getStorageSync('czLifeData');
        // 第一次打开APP，不存在lifeData变量，故放一个{}空对象
        tmp = tmp ? tmp : {};
        tmp[key] = value;
        // 执行这一步后，所有需要存储的变量，都挂载在本地的lifeData对象中
        uni.setStorageSync('czLifeData', tmp);
    }
}
const store = new Vuex.Store({
    // 下面这些值仅为示例，使用过程中请删除
    state: {
        // 如果上面从本地获取的lifeData对象下有对应的属性，就赋值给state中对应的变量
        // 加上vuex_前缀，是防止变量名冲突，也让人一目了然
        vuex_sys_version: lifeData.vuex_sys_version ? lifeData.vuex_sys_version:'3.7.0',
		current_sys: lifeData.current_sys ? lifeData.current_sys:'',//当前进入的系统标识
        current_sys_title: lifeData.current_sys_title ? lifeData.current_sys_title:'',//当前进入的系统标识
        sso_user_token: lifeData.sso_user_token ? lifeData.sso_user_token:'',
        cz_user_token: lifeData.cz_user_token ? lifeData.cz_user_token:'',
        wms_user_token: lifeData.wms_user_token ? lifeData.wms_user_token:'',
        zhfw_user_token: lifeData.zhfw_user_token ? lifeData.zhfw_user_token:'',
        cz_user_name: lifeData.cz_user_name ? lifeData.cz_user_name: '',
        cz_company_name: lifeData.cz_company_name ? lifeData.cz_company_name: '',
        cz_avatar: lifeData.cz_avatar ? lifeData.cz_avatar: '',
        cz_discount_code: lifeData.cz_discount_code ? lifeData.cz_discount_code: '',
        car_open_id: lifeData.car_open_id ? lifeData.car_open_id: '',
    },
    mutations: {
        $uStore(state, payload) {
            console.log(state,payload)
            // 判断是否多层级调用，state中为对象存在的情况，诸如user.info.score = 1
            let nameArr = payload.name.split('.');
            let saveKey = '';
            let len = nameArr.length;
            if(nameArr.length >= 2) {
                let obj = state[nameArr[0]];
                for(let i = 1; i < len - 1; i ++) {
                    obj = obj[nameArr[i]];
                }
                obj[nameArr[len - 1]] = payload.value;
                saveKey = nameArr[0];
            } else {
                // 单层级变量，在state就是一个普通变量的情况
                state[payload.name] = payload.value;
                saveKey = payload.name;
            }
            // 保存变量到本地，见顶部函数定义
            saveLifeData(saveKey, state[saveKey])
        }
    }
})

export default store
